import { Route } from '@angular/router';
//import { CanDeactivateProjectsDetails } from './projects.guards';
import { ProjectSheetsResolver, ProjectSheetResolver } from './sheets.resolvers';
import { SheetTemplatesResolver } from 'app/modules/settings/sheet-templates/sheet-templates.resolvers';
import { ProjectSheetsComponent } from './sheets.component';
import { ProjectSheetsListComponent } from './list/list.component';
import { ProjectSheetsDetailsComponent } from './details/details.component';

export const notesRoutes: Route[] = [
  {
    path: '',
    component: ProjectSheetsComponent,
    resolve: {
      projectSheets: ProjectSheetsResolver,
      sheetTemplates: SheetTemplatesResolver,
    },
    children: [
      {
        path: '',
        component: ProjectSheetsListComponent,
        resolve: {},
      },
      {
        path: ':id',
        component: ProjectSheetsDetailsComponent,
        resolve: {
          projectSheet: ProjectSheetResolver,
        },
      },
    ],
  },
];
